interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, total: number): (number | string)[] {
  if (total <= 7) {
    return Array.from({ length: total }, (_, index) => index + 1);
  }
  const pages: (number | string)[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(total - 1, page + 1);
  if (start > 2) pages.push('...');
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push('...');
  pages.push(total);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(page, totalPages);

  const baseBtn =
    'h-9 min-w-9 px-3 rounded-md text-sm font-medium flex items-center justify-center transition-colors cursor-pointer';

  return (
    <nav className="flex items-center justify-center gap-1.5 mt-10" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        className={`${baseBtn} border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:border-background-200 disabled:hover:text-foreground-700`}
      >
        <i className="ri-arrow-left-s-line md:hidden"></i>
        <span className="hidden md:inline">上一页</span>
      </button>

      <span className="hidden md:flex items-center gap-1.5">
        {pages.map((item, index) =>
          typeof item === 'number' ? (
            <button
              key={item}
              type="button"
              onClick={() => onChange(item)}
              className={`${baseBtn} ${
                item === page
                  ? 'bg-primary-500 text-background-50'
                  : 'border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
              }`}
            >
              {item}
            </button>
          ) : (
            <span key={`gap-${index}`} className="px-1 text-foreground-400">
              …
            </span>
          ),
        )}
      </span>

      <span className="md:hidden text-sm text-foreground-600 px-2">
        {page} / {totalPages}
      </span>

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        className={`${baseBtn} border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:border-background-200 disabled:hover:text-foreground-700`}
      >
        <span className="hidden md:inline">下一页</span>
        <i className="ri-arrow-right-s-line md:hidden"></i>
      </button>
    </nav>
  );
}